import { list, setArticleParams, setDirectoryParams } from '../../store/actions';

export default dispatch => ({
    fetchList: (...args) => dispatch(list(...args)),
    setArticleParams: (...args) => dispatch(setArticleParams(...args)),
    setDirectoryParams: (...args) => dispatch(setDirectoryParams(...args))
})